import { dayMonth, hour } from '@app/format';
import { t } from '@app/i18n';

/**
 * As horas da aba SPIFFE desde o aim-ivi.1 (protótipo §2.1): «Visto no gateway às 21:40», «Última renovação às 21:16»
 * e «Validade até 22:16». A hora segue a regra da foto do runtime (aim-6ph.13, decisão 7): só a hora no mesmo dia, dia
 * e mês com a hora em outro dia. Desde a regra do mrolim de 11/10/2026, a validade não diz como foi obtida.
 */

/** «às 14:05» no mesmo dia, «em 09/10 14:05» em outro: as frases curtas do «lido às» (`common.reading.at|on`). */
export function atOrOn(iso: string, now: Date = new Date()): string {
  const time = hour(iso) ?? '';
  if (sameDay(new Date(iso), now)) return t('common.reading.at', { time });
  return t('common.reading.on', { date: dayMonth(iso) ?? '', time });
}

/**
 * O `{when}` de «até {when}»: «22:16» no mesmo dia, «09/10 22:16» em outro. A data e a hora são dado, e o espaço entre
 * elas é pontuação: compõe-se aqui, e não no catálogo.
 */
export function shortWhen(iso: string, now: Date = new Date()): string {
  const time = hour(iso) ?? '';
  return sameDay(new Date(iso), now) ? time : `${dayMonth(iso) ?? ''} ${time}`;
}

function sameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
  );
}
